import { ActionTypes } from "../action-type";

const initialState={
    removed:false
}

export const removeMemberReducer = (state = initialState,action)=>{
    switch(action.type){
        case ActionTypes.REMOVE_MEMBER:
            return{
                ...state,removed:action.payload
            }
        default:
            return state;
    }
}